<template>
  <div class="products-page">
    <section class="page-hero">
      <span>PRODUCT COLLECTION</span>
      <h1>{{ $t('products.title') }}</h1>
      <p>{{ intro }}</p>
    </section>

    <section class="catalog">
      <div class="filter-bar">
        <button v-for="filter in filters" :key="filter.type" :class="{active: productType === filter.type}" @click="changeType(filter.type)">
          {{ filter.name }}
        </button>
      </div>
      <transition-group name="catalog" tag="div" class="product-grid">
        <router-link v-for="item in filteredProducts" :key="item.link + item.image" :to="item.link" class="product-card">
          <div class="product-image"><img :src="item.image" :alt="productName(item)"></div>
          <div class="product-info">
            <div><span>{{ categoryName(item.type) }}</span><h2>{{ productName(item) }}</h2></div>
            <b>↗</b>
          </div>
        </router-link>
      </transition-group>
    </section>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Products',
  data() { return { productList: [], productType: 'all' }; },
  computed: {
    isEnglish() { return this.$i18n.locale.indexOf('en') !== -1; },
    intro() {
      return this.isEnglish
        ? 'Explore smart wearables and mechanical timepieces built around precision, reliability, and thoughtful interaction.'
        : '探索以精密、可靠与自然交互为核心的智能穿戴及机械时计产品。';
    },
    filters() {
      const list = this.$t('products').titleList[0];
      return [
        { name: list.t_1, type: 'all' },
        { name: list.t_2s[0], type: 'smart' },
        { name: list.t_2s[1], type: 'yx' },
        { name: list.t_2s[2], type: 'glb' }
      ];
    },
    filteredProducts() {
      return this.productType === 'all' ? this.productList : this.productList.filter(item => item.type === this.productType);
    }
  },
  created() { axios.get('productList.json').then(res => { this.productList = res.data; }); },
  methods: {
    changeType(type) { this.productType = type; },
    productName(item) { return item.name.indexOf('.') !== -1 ? this.$t(item.name) : item.name; },
    categoryName(type) {
      const filter = this.filters.find(item => item.type === type);
      return filter ? filter.name : '';
    }
  },
  mounted() { document.body.className = 'site-page'; }
};
</script>

<style lang="stylus" scoped>
.products-page
  min-height 70vh
  color #111c39
  background #f6f8fc
.page-hero
  max-width 1344px
  margin 0 auto
  padding 86px 48px 62px
  span
    display inline-block
    color #3566d4
    font-size 12px
    font-weight 750
    letter-spacing .08em
  h1
    margin 15px 0 16px
    padding 0
    font-size clamp(46px,6vw,78px)
    line-height 1.12
    letter-spacing -.055em
  p
    max-width 680px
    margin 0
    color #68758f
    font-size 17px
    line-height 1.8
.catalog
  max-width 1344px
  margin 0 auto
  padding 0 48px 110px
.filter-bar
  display flex
  flex-wrap wrap
  gap 10px
  padding 18px
  margin-bottom 34px
  border 1px solid #e3e8f2
  border-radius 18px
  background rgba(255,255,255,.82)
  button
    padding 10px 18px
    color #63708a
    border 0
    border-radius 999px
    background transparent
    cursor pointer
    font-weight 600
    transition all .25s ease
    &.active, &:hover
      color #fff
      background #2459d5
.product-grid
  display grid
  grid-template-columns repeat(3,minmax(0,1fr))
  gap 24px
.product-card
  min-width 0
  color inherit
  border 1px solid #e4e9f2
  border-radius 24px
  overflow hidden
  background #fff
  text-decoration none
  transition transform .3s ease, box-shadow .3s ease
  &:hover
    transform translateY(-6px)
    box-shadow 0 24px 60px rgba(30,48,100,.13)
.product-image
  height 330px
  padding 22px
  background linear-gradient(145deg,#fafbfe,#edf2f9)
  img
    display block
    width 100%
    height 100%
    object-fit contain
.product-info
  min-height 112px
  padding 22px 24px
  display flex
  align-items center
  justify-content space-between
  gap 16px
  span
    color #7c89a2
    font-size 10px
    letter-spacing .12em
  h2
    margin 7px 0 0
    font-size 20px
  b
    color #2d61d2
.catalog-enter-active,.catalog-leave-active
  transition all .25s ease
.catalog-enter,.catalog-leave-to
  opacity 0
  transform translateY(12px)
@media (max-width: 900px)
  .product-grid
    grid-template-columns repeat(2,minmax(0,1fr))
@media (max-width: 620px)
  .page-hero
    padding 58px 20px 42px
  .catalog
    padding 0 20px 72px
  .filter-bar
    padding 10px
  .product-grid
    grid-template-columns 1fr
  .product-image
    height 285px
</style>
